import { render } from "./TaskReference.vue?vue&type=template&id=a6ebf9d6"
import script from "./TaskReference.vue?vue&type=script&lang=js"
export * from "./TaskReference.vue?vue&type=script&lang=js"

import "./TaskReference.vue?vue&type=style&index=0&id=a6ebf9d6&lang=css"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__